export const WEBSIM_TAG_ID_ATTRIBUTE = "w-tid";
